const _excluded = ["show", "licenseData"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getAccOrigin } from '@adsk/acs-sc-web-platform-api';
import { Box } from '@adsk/alloy-react-box';
import EmptyState from '@adsk/alloy-react-empty-state';
import Illustration from '@adsk/alloy-react-illustration';
import { useLocale } from '@adsk/alloy-react-locale';
import { SimpleModal } from '@adsk/alloy-react-modal';
import AutomaticAboutBoxContent from './AutomaticAboutBoxContent';
import { CURRENT_YEAR_PLACEHOLDER, INTRODUCTION } from '../consts';
import { licenseDataShape } from '../helpers/propTypes';
const AboutBoxModal = _ref => {
  let {
      show,
      licenseData
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../i18n/".concat(locale, ".json"));
  });
  const [data, setData] = useState(licenseData);
  const [error, setError] = useState(false);
  const linkRegex = /<a.*?\/a>/g;
  useEffect(() => {
    let cancel = false;
    if (show && !licenseData) {
      fetch("".concat(getAccOrigin(), "/assets/license-manager/licenseCollections.json")).then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error('License failed to load.');
        }
      }).then(newData => {
        if (!cancel) {
          setData(newData);
        }
      }).catch(() => {
        if (!cancel) {
          setError(true);
        }
      });
    }
    return () => {
      cancel = true;
    };
  }, [show, licenseData]);
  return /*#__PURE__*/React.createElement(SimpleModal, _extends({
    title: T.translate('TRADEMARKS_CREDITS_AND_ATTRIBUTIONS'),
    modalBodyProps: {
      style: _objectSpread({
        overflow: 'hidden',
        overflowY: 'auto'
      }, error && {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center'
      })
    },
    show: show
  }, props), data && INTRODUCTION.map(line => {
    var _line$text$match;
    const textArr = line.text.replace(CURRENT_YEAR_PLACEHOLDER, new Date().getFullYear().toString()).replace(linkRegex, '-').split('-');
    const links = line.text.match(linkRegex) && ((_line$text$match = line.text.match(linkRegex)) === null || _line$text$match === void 0 ? void 0 : _line$text$match.map(link => {
      var _link$match, _link$match2;
      return {
        href: (_link$match = link.match(/href="(.*)">/)) === null || _link$match === void 0 ? void 0 : _link$match[1],
        text: (_link$match2 = link.match(/>(.*)</)) === null || _link$match2 === void 0 ? void 0 : _link$match2[1]
      };
    }));
    return /*#__PURE__*/React.createElement(Box, {
      key: line.text,
      margin: "10px 0 4px"
    }, textArr.map((text, i) => /*#__PURE__*/React.createElement(Fragment, {
      key: text
    }, /*#__PURE__*/React.createElement("span", null, text), links && links[i] && /*#__PURE__*/React.createElement("a", {
      href: links[i].href
    }, links[i].text))));
  }), /*#__PURE__*/React.createElement(AutomaticAboutBoxContent, {
    collections: data
  }), !data && error && /*#__PURE__*/React.createElement(EmptyState, {
    title: T.translate('ERROR_LOADING_LICENSES'),
    illustrationType: Illustration.TYPES.FOLDER_EMPTY_GREY,
    description: T.translate('ERROR_LOADING_THIRD_PARTY'),
    style: {
      marginTop: -12
    } // Visually center error block
  }));
};
AboutBoxModal.displayName = 'AboutBoxModal';
AboutBoxModal.propTypes = {
  /** Whether to show the modal or not */
  show: PropTypes.bool.isRequired,
  /** A callback function for when trying to close the modal */
  onClose: PropTypes.func.isRequired,
  /** Use alternative license data (for demo purposes), this data is fetched by default */
  licenseData: licenseDataShape
};
export default AboutBoxModal;
//# sourceMappingURL=AboutBoxModal.js.map